import axios from 'axios';

import type { PostRequest, PostUserQueryResult } from './request';

export type PostSendUserQueryApiCall = (data: PostRequest['body']) => Promise<PostUserQueryResult>;

const AI_COMPANION_POST_USER_QUERY_CLIENT_ENDPOINT = '/api/ai-companion/send-user-query';
const AI_COMPANION_TIMEOUT = 180000;

export const sendUserQueryApi: PostSendUserQueryApiCall = async (data) => {
	const res = await axios.post(AI_COMPANION_POST_USER_QUERY_CLIENT_ENDPOINT, data, { timeout: AI_COMPANION_TIMEOUT });
	return res.data;
};
